module.exports = __webpack_public_path__ + "img/pdf.b0ace995.svg";